module.exports = __webpack_public_path__ + "static/media/data-logo.0abcdfba.svg";